const ACCORDION_CAPTURE_WAIT_TIMEOUT_MS = 2000;

/**
 * Coordinates MUI accordion `onEntered` callbacks during print chart capture.
 */
export function createAccordionCaptureEnteredWaiters() {
  let resolvePricingChartsEntered = null;
  let resolveProductSnapshotEntered = null;

  return {
    notifyPricingChartsAccordionEntered() {
      if (resolvePricingChartsEntered) {
        resolvePricingChartsEntered();
        resolvePricingChartsEntered = null;
      }
    },
    notifyProductSnapshotAccordionEntered() {
      if (resolveProductSnapshotEntered) {
        resolveProductSnapshotEntered();
        resolveProductSnapshotEntered = null;
      }
    },
    waitForPricingReportAccordionsExpandedForCapture({
      pricingChartsWasCollapsed,
      productSnapshotWasCollapsed,
    }) {
      const promises = [];

      if (pricingChartsWasCollapsed) {
        promises.push(
          new Promise((resolve) => {
            resolvePricingChartsEntered = resolve;
          })
        );
      }

      if (productSnapshotWasCollapsed) {
        promises.push(
          new Promise((resolve) => {
            resolveProductSnapshotEntered = resolve;
          })
        );
      }

      if (promises.length === 0) {
        return Promise.resolve();
      }

      return Promise.race([
        Promise.all(promises),
        new Promise((resolve) => setTimeout(resolve, ACCORDION_CAPTURE_WAIT_TIMEOUT_MS)),
      ]);
    },
  };
}
